import React from 'react'
import {Col, Container, Row} from "react-bootstrap";

interface ContentWrapperProps {
    contentKey: string;
    currentContent: any;
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({contentKey, currentContent}) => {
    return (
        <Container
                   className={`d-flex align-items-center ${currentContent.className} ${currentContent.colorTexto}`}>
            <Row className="w-100">
                <Col>
                    <h1 className="titulo-con text-center pb-3">{currentContent.titulo}</h1>
                    <div className="lh-1 text-size"
                         dangerouslySetInnerHTML={{__html: `<div>${currentContent.text}</div>`}}/>
                </Col>
            </Row>
        </Container>
    )
}

export default ContentWrapper;